const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <img
              src="https://static.readdy.ai/image/0c9ab602efd3f666fe992585e0daf840/7111f617ff52b664a5493fd29ab7be63.jpeg"
              alt="Logo"
              className="h-16 w-auto object-contain mb-6"
            />
            <p className="text-gray-400 text-sm font-light leading-relaxed max-w-sm mb-8">
              Distribuidores autorizados de skincare de calidad en Costa Rica. Especializados en La Roche-Posay y las mejores marcas internacionales de cuidado de la piel, con productos testados dermatológica y clínicamente.
            </p>
            <div className="flex items-center space-x-5">
              <a href="https://www.instagram.com/beautydeals_cr?igsh=MWhzajEwYzYzMTN5eQ==" target="_blank" rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white hover:text-gray-900 transition-all cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://www.facebook.com/share/1CDauG7Y85/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white hover:text-gray-900 transition-all cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.tiktok.com/@beautydealscr?_r=1&_t=ZS-94c9jdGGxeL" target="_blank" rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white hover:text-gray-900 transition-all cursor-pointer">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="https://wa.me/50661025212" target="_blank" rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white hover:text-gray-900 transition-all cursor-pointer">
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a href="mailto:beautydealscr@gmail.com"
                className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white hover:text-gray-900 transition-all cursor-pointer">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-4 space-y-8">
            <div>
              <h4 className="text-xs font-semibold tracking-wider text-gray-500 uppercase mb-3">UBICACIÓN</h4>
              <p className="text-white text-sm font-light leading-relaxed">
                Costa Rica<br />Distribución a todo el país
              </p>
            </div>
            <div>
              <h4 className="text-xs font-semibold tracking-wider text-gray-500 uppercase mb-3">WHATSAPP</h4>
              <p className="text-white text-sm font-light">+506 6102-5212</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold tracking-wider text-gray-500 uppercase mb-3">CORREO</h4>
              <p className="text-white text-sm font-light">beautydealscr@gmail.com</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold tracking-wider text-gray-500 uppercase mb-4">NAVEGACIÓN</h4>
              <div className="flex flex-col space-y-2">
                {[
                  { label: 'Productos', id: 'productos' },
                  { label: 'Cuidado de la Piel', id: 'cuidado' },
                  { label: 'Calidad', id: 'aprobacion' },
                  { label: 'Venta al Por Mayor', id: 'distribucion' },
                ].map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className="text-left text-gray-400 text-sm font-light hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <img
              src="https://readdy.ai/api/search-image?query=premium%20La%20Roche-Posay%20skincare%20serums%20and%20moisturizers%20elegantly%20arranged%20on%20white%20marble%20surface%20with%20warm%20soft%20lighting%2C%20luxury%20imported%20cosmetics%20product%20photography%20with%20clean%20minimalist%20background%20and%20golden%20tones&width=300&height=400&seq=footerimg2cr&orientation=portrait"
              alt="Skincare distribuidores autorizados"
              className="w-full h-80 object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-gray-500 text-xs">
              © 2025 Beauty Deals CR. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-8">
              <button onClick={() => scrollToSection('inicio')} className="text-gray-500 text-xs hover:text-white transition-colors cursor-pointer">Privacidad</button>
              <button onClick={() => scrollToSection('inicio')} className="text-gray-500 text-xs hover:text-white transition-colors cursor-pointer">Términos</button>
              <button onClick={() => scrollToSection('aprobacion')} className="text-gray-500 text-xs hover:text-white transition-colors cursor-pointer">Calidad</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
